import { combineReducers } from 'redux';
import user from './user';
import loaders from './loaders';
import errors from './errors';
import users from './users';
import handbook from './handbook';
import orders from './orders';
import goods from './goods';
import settings from './settings';
import promocodes from './promocodes';
import messages from './messages';
import ratings from './ratings';
import statistics from './statistics';
import news from './news';
import documentation from './documentation';
import good from './good';
import modals from './modals';
import sliders from './sliders';
import logs from './logs';
import ips from './ips';
import yookassa from './yookassa';
import phonecodes from './phonecodes';
import yumaposgoodsmap from './yumaposgoodsmap';
import neworders from './neworder';
import points from "./points";
import inventoryForms from "./inventoryforms";
import invoiceforms from "./invoiceforms";
import suppliers from "./suppliers";
import UImobile from './UImobile';
import writeoffs from "./writeoffs";
import reasons from "./reasons";
import promotions from './promotions';
import historyOrders from './historyOrders';
import productCategories from "./productCategories";
import UIsortMobile from "./UIsortMobile";
import cassa from './cassa';
import raw from './raw';
import recipes from './recipes';
import notifications from './notifications';
import reports from './reports';
import automaticConsumption from './automaticConsumption';
import wageFund from './wageFund';
import deliveryMap from './delivery-map';
import blockedOrders from './blockedOrders';

const rootReducer = combineReducers({
  user,
  users,
  loaders,
  errors,
  handbook,
  messages,
  orders,
  goods,
  settings,
  promocodes,
  ratings,
  statistics,
  news,
  documentation,
  good,
  points,
  inventoryForms,
  invoiceforms,
  suppliers: suppliers,
  productCategories,
  writeoffs,
  reasons,
  modals,
  sliders,
  logs,
  yookassa,
  ips,
  phonecodes,
  yumaposgoodsmap,
  neworders,
  UImobile,
  UIsortMobile,
  promotions,
  historyOrders,
  cassa,
  raw,
  recipes,
  notifications,
  reports,
  automaticConsumption,
  wageFund,
  deliveryMap,
  blockedOrders,
});

export default rootReducer;